import { FunctionComponent, SVGProps } from "react";

import defaultTranslations from "../i18n/en";

export type I18n = typeof defaultTranslations;

export enum Language {
  English = "en",
}

export type Glyph = FunctionComponent<SVGProps<SVGSVGElement>>;
